import { Directive} from '@angular/core';

@Directive({
  selector: '[libCarouselItem]'
})
export class CarouselItemDirective {
  constructor( ) {
  }
}